// power bi 嵌入网页
import CommonUtil from './util';
import { service, factories, models, IEmbedConfiguration } from "powerbi-client";
const powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
const loadEmbedPage = (dom_obj, config, access_token) => {
    const embed_config = {
        type: "report",
        // tokenType: models.TokenType.Aad,
        accessToken: access_token,
        embedUrl: config.embedUrl,
        id: config.id,
        settings: {
            // 筛选框
            filterPaneEnabled: false,
            // 多页导航
            // navContentPaneEnabled: false
        }
    };
    // "embed" function return a report instance
    return powerbi.embed(dom_obj, embed_config);
};

const getAccessToken = () => {
    return new Promise((resolve, reject) => {
        CommonUtil.ajax.get(CommonUtil.api.power_bi_access_token).then((response) => {
            return response.data
        }).then((res) => {
            if (res.code === 1) {
                resolve(res.data.access_token);
            } else {
                window.eventHub.$emit('error', {message: res.msg});
            }
        }).catch((e) => {
            console.log(e);
            window.eventHub.$emit('error', e);
        });
    })
};

const updateToken = async(report) => {
    const new_token = await getAccessToken();
    report.setAccessToken(new_token);
    report.refresh();
};


const util = {
    /*
    * 请在 mounted 之后调用该函数，dom 元素在 mounted 之后才会生成
    * @params
    * dom_obj: dom元素，可通过 document.getElementById 或 vue 实例的 this.$refs['ref_name'] 获取
    * workspace_id: power bi 的工作区ID
    * report_id: power bi 的报表ID
    * */
    async embed(dom_obj, workspace_id, report_id) {
        const access_token = await getAccessToken();
        const url = `https://api.powerbi.cn/v1.0/myorg/groups/${workspace_id}/reports/${report_id}`;
        CommonUtil.ajax.get(url, {
            headers: {
                "Authorization": "Bearer " + access_token
            },
        }).then((response) => {
            return response.data;
        }).then((res) => {
            const report = loadEmbedPage(dom_obj, res, access_token);
            // todo rm line below
            window.report = report;
            report.off("loaded");
            report.on("loaded", function() {
                console.log("Report load successful");
            });

            report.off("rendered");
            report.on("rendered", function(event) {
                console.log('report rendered:', event);
            });

            report.off("error");
            report.on("error", function(event) {
                console.error('report error:', event);
                const errorMsg = event.detail;
                // update token when "TokenExpired"
                if (errorMsg.message === 'TokenExpired') {
                    updateToken(report);
                }
            });
        }).catch((e) => {
            window.eventHub.$emit('error', {message: e.message});
        });
    }
};

export default util;
